import { combineReducers } from '@reduxjs/toolkit';

import countryReducer from './countrySlice';
import dateFormatReducer from './date-format-slice';
import regionReducer from './region-slice';
import timeZoneReducer from './timezoneSlice';

const adminReducer = combineReducers({
  country: countryReducer,
  region: regionReducer,
  timeZone: timeZoneReducer,
  dateFormat: dateFormatReducer,
});

export default adminReducer;
